// routes.js

import Main from "./components/Layouts/Main";
import UnderMaintenance from "./components/Layouts/UnderMaintenance";
import AddExpense from "./view/AddNewExpense";
import Currency from "./view/Currency";
import Dashboard from "./view/Dashboard";
import Departments from "./view/Departments";
import ExpenseCalendarControl from "./view/ExpenseCalendarControl";
import ExpenseCode from "./view/ExpenseCode";
import ListOfExpense from "./view/ListOfExpense";
import DraftExpenseRequest from "./view/ListOfExpense/draftExpenseRequest";
import ExpenseListingDetail from "./view/ListOfExpense/expenseListingDetail";

import Notifications from "./view/Notifications";
import NotificationDetail from "./view/Notifications/notificationDetail";
import PendingRequests from "./view/PendingRequests";
import PendingRequestDetail from "./view/PendingRequests/pendingRequestDetail";
import PendingUserConfiguration from "./view/PendingUserConfiguration";
import Permissions from "./view/Permissions";
import ProjectCode from "./view/ProjectCode";
import Roles from "./view/Roles";
import Settings from "./view/Settings";
import Users from "./view/Users";

export const componentMap = {
  "/dashboard": (
    <Main children={<Dashboard />} key_elem="1" nameLink="Dashboard" />
  ),
  "/add-expense": (
    <Main children={<AddExpense />} key_elem="2" nameLink="Add Expense" />
  ),
  "/list-of-expense": (
    <Main
      children={<ListOfExpense />}
      key_elem="3"
      nameLink="List of Expense"
    />
  ),
  "/list-of-expense/:id": (
    <Main
      children={<ExpenseListingDetail />}
      key_elem={"4"}
      nameLink="Expense Listing Detail"
    />
  ),
  "/list-of-expense/draft/:id": (
    <Main
      children={<DraftExpenseRequest />}
      key_elem={"4"}
      nameLink="Draft Expense Request"
    />
  ),
  "/pending-requests": (
    <Main
      children={<PendingRequests />}
      key_elem="5"
      nameLink="Pending Requests"
    />
  ),
  "/pending-requests/:id": (
    <Main
      children={<PendingRequestDetail />}
      key_elem={"6"}
      nameLink="Pending Request Detail"
    />
  ),
  "/expense-code": (
    <Main children={<ExpenseCode />} key_elem="7" nameLink="Expense Code" />
  ),
  "/project-code": (
    <Main children={<ProjectCode />} key_elem="8" nameLink="Project Code" />
  ),
  "/settings": (
    <Main children={<Settings />} key_elem="9" nameLink="Settings" />
  ),
  "/users": <Main children={<Users />} key_elem="10" nameLink="Users" />,
  "/pending-user-configuration": (
    <Main
      children={<PendingUserConfiguration />}
      key_elem="11"
      nameLink="Pending User Configuration"
    />
  ),
  "/permissions": (
    <Main children={<Permissions />} key_elem="12" nameLink="Permissions" />
  ),
  "/roles": <Main children={<Roles />} key_elem="13" nameLink="Roles" />,
  "/departments": (
    <Main children={<Departments />} key_elem="14" nameLink="Departments" />
  ),
  "/notifications": (
    <Main children={<Notifications />} key_elem="15" nameLink="Notifications" />
  ),
  "/notifications/:id": (
    <Main
      children={<NotificationDetail />}
      key_elem={"16"}
      nameLink="Notification Detail"
    />
  ),
  "/currency": (
    <Main children={<Currency />} key_elem="17" nameLink="Currency" />
  ),

  "/expense-calendar-control": (
    <Main
      children={<ExpenseCalendarControl />}
      key_elem="18"
      nameLink="Expense Calendar Control"
    />
  ),
  noRoute: "/404",
  "/underMaintenance": <UnderMaintenance />,
};

export const roles = {
  SUPERADMIN: [
    "/dashboard",
    "/departments",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/pending-requests",
    "/pending-requests/:id",
    "/expense-code",
    "/project-code",
    "/permissions",
    "/roles",
    "/users",
    "/pending-user-configuration",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
    "/currency",
    "/settings",
    "/expense-calendar-control",
  ],
  ADMIN: [
    "/dashboard",
    "/departments",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/pending-requests",
    "/pending-requests/:id",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
    "/project-code",
    "/expense-code",
    "/currency",
    "/expense-calendar-control",
    "/pending-user-configuration",
  ],
  APPROVER: [
    "/dashboard",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/pending-requests",
    "/pending-requests/:id",
    "/project-code",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
  ],
  EMPLOYEE: [
    "/dashboard",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/project-code",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
  ],
};
